<template>
  <div>
    <a-modal
      :dialog-style="{ top: '10px' }"
      :title="
        $t('appreciation.adminAppreciation') +
        ': ' +
        selectedStudentRecord.fullName
      "
      :visible="visibleAppreciationModal"
      width="90%"
      height="90%"
      @cancel="() => (visibleAppreciationModal = false)"
      @ok="() => (visibleAppreciationModal = false)"
    >
      <div style="width: 100%; height: 70vh">
        <div class="row" style="height: 100%">
          <div class="col-7">
            <div
              v-if="loadingPdfPreview"
              style="
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <a-col :span="16" :offset="16">
                <a-spin size="large" />
              </a-col>
            </div>
            <iframe
              v-else
              :src="pdfBlobUrl"
              style="background-color: #eee; height: 100%; width: 100%"
            >
            </iframe>
          </div>
          <div class="col-1" style="flex: 0 0 1.333333%">
            <a-divider type="vertical" style="height: 100%" />
          </div>
          <div class="col-4">
            <a-divider>{{ $t("bulletin.directorNotesOnBehaviorAndAttendance") }}</a-divider>
            <div class="appreciation-container">
              <a-form-item :label="$t('appreciation.insertPredefinedAppreciation')">
                <a-select
                  v-model="selectedPredefinedAppreciation"
                  :placeholder="$t('appreciation.insertPredefinedAppreciation')"
                  style="width: 100%"
                  @change="handlePredefinedAppreciationSelect"
                  allowClear
                  :disabled="!!currentAppreciation && !selectedPredefinedAppreciation"
                  :show-search="true"
                  :not-found-content="null"
                  :default-active-first-option="false"
                >
                  <a-select-option
                    v-for="(appreciation, index) in filteredAppreciations"
                    :key="index"
                    :value="appreciation"
                  >
                    {{ appreciation }}
                  </a-select-option>
                </a-select>
              </a-form-item>

              <div style="text-align: center; margin: 10px 0">
                <span style="color: #999">{{ $t('all.or') }}</span>
              </div>

              <a-form-item :label="$t('appreciation.customAppreciation')">
                <a-textarea
                  :maxLength="140"
                  :disabled="loadingPdfPreview || !!selectedPredefinedAppreciation"
                  v-model="currentAppreciation"
                  :placeholder="$t('appreciation.customAppreciation')"
                  :auto-size="{ minRows: 4, maxRows: 6 }"
                  @input="handleCustomAppreciationInput"
                />
              </a-form-item>
            </div>
            <div class="row mt-3">
              <div class="col m-auto test-center">
                <a-button
                  :loading="loadingDelete"
                  :disabled="loadingDelete"
                  @click="
                    () => {
                      deleteStudentAppreciation(selectedStudentRecord._id);
                    }
                  "
                  icon="delete"
                  type="danger"
                  style="width: 100%"
                  >{{ $t("action.supprimer") }}</a-button
                >
              </div>
              <div class="col m-auto test-center">
                <a-button
                  icon="save"
                  type="primary"
                  :loading="loadingSave"
                  :disabled="loadingSave"
                  @click="
                    () => {
                      saveStudentAppreciation(selectedStudentRecord._id);
                    }
                  "
                  style="width: 100%"
                  >{{ $t("action.enregistrer") }}</a-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="visibleClone"
      centered
      @cancel="visibleClone=false"
      width="70%"
      :footer="false"
    >
      <template slot="title">
        <div class="text-center">
          <h4 class="mb-0">{{ $t("bulletin.duplicateSettings") }}</h4>
        </div>
      </template>

      <div class="p-3">
        <div class="mb-4">
          <a-divider orientation="left">{{ $t("bulletin.source") }}</a-divider>
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label">
                {{ $t("etablissement.type") }}
              </label>
              <a-select
                class="w-100"
                v-model="sourceType"
                allow-clear
                @change="handleSourceTypeChange"
                :placeholder="$t('etablissement.type')"
              >
                <a-select-option
                  v-for="(value, key) in builletinTypesNames"
                  :key="key"
                  :value="key"
                >
                  {{ value }}
                </a-select-option>
              </a-select>
            </div>
            <div class="col-md-2">
              <label class="form-label">
                {{ $t("emploi.trimestre") }}<span class="text-danger">*</span>
              </label>
              <a-select
                class="w-100"
                allow-clear
                v-model="sourceTrim"
                @change="validateCloneForm"
                :placeholder="$t('emploi.trimestre')"
              >
                <a-select-option
                  v-for="(value, index) in ['1', '2', '3']"
                  :key="index"
                  :value="value"
                >
                  {{ value }}
                </a-select-option>
              </a-select>
            </div>
            <div class="col-md-3">
              <label class="form-label">
                {{ $t("etablissement.niveau") }}
              </label>
              <a-select
                class="w-100"
                v-model="sourceLevel"
                allow-clear
                @change="handleSourceLevelChange"
                :placeholder="$t('etablissement.niveau')"
                :show-search="true"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="(value, name) in levelSelectData"
                  :key="name"
                  :value="name"
                >
                  {{ value }}
                </a-select-option>
              </a-select>
            </div>
            <div class="col-md-3">
              <label class="form-label">
                {{ $t("etablissement.classe") }}
              </label>
              <a-select
                class="w-100"
                v-model="sourceClass"
                allow-clear
                @change="handleSourceClassChange"
                :placeholder="$t('etablissement.classe')"
                :show-search="true"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="classroom in classes"
                  :key="classroom._id"
                  :value="classroom._id"
                >
                  {{ classroom.name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <a-divider orientation="left">{{ $t("bulletin.destination") }}</a-divider>
          <div class="row g-3">
            <div class="col-md-12">
              <label class="form-label">
                {{ $t("etablissement.type") }}<span class="text-danger">*</span>
              </label>
              <a-select
                class="w-100"
                v-model="targetType"
                allow-clear
                @change="validateCloneForm"
                :placeholder="$t('etablissement.type')"
              >
                <a-select-option
                  v-for="(value, key) in filteredTargetTypes"
                  :key="key"
                  :value="key"
                  :disabled="key === sourceType"
                >
                  {{ value }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>

        <!-- Action Button -->
        <div class="row mt-4">
          <div class="col-md-4 offset-md-8">
            <a-button
              type="primary"
              class="w-100"
              @click="handleClone"
              :disabled="!isCloneFormValid"
              :loading="loadingClone"
            >
              <a-icon type="copy" />
              {{ $t("all.apply") }}
            </a-button>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="visibleBulkAppreciation"
      :title="$t('appreciation.bulkAppreciation')"
      @ok="handleBulkAppreciation"
      @cancel="closeBulkAppreciationModal"
      :confirm-loading="bulkLoading"
    >
      <a-form :form="bulkAppreciationForm" layout="vertical">
        <a-form-item :label="$t('appreciation.selectAppreciation')">
          <a-select
            v-decorator="['selectedAppreciation']"
            :placeholder="$t('appreciation.selectPredefinedAppreciation')"
            @change="handlePredefinedSelect"
            allowClear
            style="width: 100%"
          >
            <a-select-option
              v-for="(appreciation, index) in predefinedAppreciations"
              :key="index"
              :value="appreciation"
            >
              {{ appreciation }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <div style="text-align: center; margin: 10px 0">
          <span style="color: #999">{{ $t('all.or') }}</span>
        </div>

        <a-form-item :label="$t('appreciation.customAppreciation')">
          <a-textarea
            v-decorator="['customAppreciation']"
            :placeholder="$t('appreciation.customAppreciation')"
            :auto-size="{ minRows: 3 }"
            @change="handleCustomInput"
            :disabled="!!bulkAppreciationForm.getFieldValue('selectedAppreciation')"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <div>
      <div class="row success">
        <div class="col-xl-8">
          <h5 style="margin-bottom: 30px">
            <span style="margin-right: 30px">{{
              $t("appreciation.adminAppreciation")
            }}</span>
          </h5>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-9">
          <label>{{ $t("bulletin.listeClasses") }}</label>
          <a-select
            show-search
            :placeholder="$t('emploi.listeClasses')"
            option-filter-prop="children"
            :filter-option="filterOption"
            style="width: 150px; margin-left: 10px"
            @change="
              (val) => {
                handleClassChange('classe', val);
              }
            "
          >
            <a-select-option value="all">---</a-select-option>
            <a-select-option
              v-for="classe in classes"
              :key="classe._id"
              :value="classe._id"
              >{{ classe.name }}</a-select-option
            >
          </a-select>

          <label style="margin-left: 15px; margin-right: 20px">{{ this.$t("emploi.trimestre") }}</label>
          <a-select
            :placeholder="$t('paiement.selectionnerMois')"
            style="width: 100px; "
            @change="handleTrimesterChange"
            :value="selectedTrimester"
          >
            <a-select-option
              v-for="trimester in ['1', '2', '3']"
              :key="trimester"
              :value="trimester"
              >{{ trimester }}</a-select-option
            >
          </a-select>
          <a-button
            type="primary"
            icon="copy"
            style="margin-left: 10px"
            @click="openCloneModal"
          >
            {{ $t("action.clone") }}
          </a-button>
          <a-button
          v-if="selectedRowKeys.length > 0"
          type="primary"
          icon="message"
          style="margin-left: 10px"
          @click="showBulkAppreciationModal"
        >
          {{ $t('appreciation.giveAppreciation') }} ({{ selectedRowKeys.length }})
         </a-button>
        </div>
        <div class="col-xl-4" >

        </div>
        <div class="col-xl-4" >


  </div>
      </div>
      <a-divider></a-divider>
      <div class="row">
        <div class="col-xl-12">
          <div class="card" v-if="selectedClasse">
            <div class="data-table">
              <a-table
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              @change="tableChanged"
              :loading="tableLoading"
              :pagination="false"
              :data-source="activeData"
              :columns="columns"
              :rowClassName="() => 'editable-row'"
              @row="(record) => ({ on: { click: () => onStudentClick(record) } })"
                :customRow="
                  (record) => {
                    return {
                      on: {
                        click: (event) => {
                          this.onStudentClick(record);
                        },
                      },
                    };
                  }
                "
              >
                <template slot="moyenne" slot-scope="text, record">
                  {{ getStudentMoyenne(record._id) }}
                </template>

                <template slot="appreciation" slot-scope="text, record">
                  {{ getStudentAppreciation(record._id) }}
                </template>

                <template slot="name" slot-scope="text">
                  <span class="arabic-font">{{ text }}</span>
                </template>

                <div
                  slot="filterDropdown"
                  slot-scope="{
                    setSelectedKeys,
                    selectedKeys,
                    confirm,
                    clearFilters,
                    column,
                  }"
                  style="padding: 8px"
                >
                  <a-input
                    v-ant-ref="(c) => (searchInput = c)"
                    :placeholder="`${$t('personnel.chercher')} ${column.title}`"
                    :value="selectedKeys[0]"
                    style="width: 188px; margin-bottom: 8px; display: block"
                    @change="
                      (e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    "
                    @pressEnter="
                      () =>
                        handleSearch(selectedKeys, confirm, column.dataIndex)
                    "
                  />
                  <a-button
                    type="primary"
                    icon="search"
                    size="small"
                    style="width: 90px; margin-right: 8px"
                    @click="
                      () =>
                        handleSearch(selectedKeys, confirm, column.dataIndex)
                    "
                    >{{ $t("paiement.chercher") }}</a-button
                  >
                  <a-button
                    size="small"
                    style="width: 90px"
                    @click="() => handleReset(clearFilters)"
                    >{{ $t("action.reinitialiser") }}</a-button
                  >
                </div>
                <a-icon
                  slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }"
                />
                <template
                  slot="customRender"
                  slot-scope="text, record, index, column"
                >
                  <span
                    v-if="searchText && searchedColumn === column.dataIndex"
                  >
                    <template
                      v-for="(fragment, i) in text
                        .toString()
                        .split(
                          new RegExp(
                            `(?<=${searchText})|(?=${searchText})`,
                            'i'
                          )
                        )"
                    >
                      <mark
                        v-if="
                          fragment.toLowerCase() === searchText.toLowerCase()
                        "
                        :key="i"
                        class="highlight"
                        >{{ fragment }}</mark
                      >
                      <template v-else>{{ fragment }}</template>
                    </template>
                  </span>
                  <template v-else>{{ text }}</template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
//ANCHOR class/month filter to this view: DONE

import apiClient from "@/services/axios";
import { mapState } from "vuex";
import { getLevels } from "@/config/LevelConstants";
import "jspdf-autotable";
import { notification, Modal } from "ant-design-vue";
import moment from "moment";
const pedaHandler = require("./../studentMarks/scripts/bulletinHeplers/peda").default;
const specPiloteHandler = require("./../studentMarks/scripts/bulletinHeplers/bulletin").default;
const bulletinHeplers = {
  MP:pedaHandler,
  MT:specPiloteHandler,
  MS:specPiloteHandler
}
export default {
  computed: {
    ...mapState(["settings", "user"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      return getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
    },
    columns() {
      return [
        {
          title: this.$t("bulletin.nom"),
          dataIndex: "fullName",
          key: "fullName",
          scopedSlots: {
            customRender: "fullName",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) =>
            record.name.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("bulletin.moyenne"),
          dataIndex: "moyenne",
          scopedSlots: { customRender: "moyenne" },
          sorter: (a, b) =>
            Number(this.getStudentMoyenne(a._id)) -
            Number(this.getStudentMoyenne(b._id)),
        },
        {
          title: this.$t("appreciation.appreciation"),
          dataIndex: "appreciation",
          scopedSlots: { customRender: "appreciation" },
        },
      ];
    },
    filteredTargetTypes() {
      if (!this.sourceType) return this.builletinTypesNames;
      return Object.fromEntries(
        Object.entries(this.builletinTypesNames).filter(([key]) => key !== this.sourceType)
      );
    },
    isCloneFormValid() {
      const hasSourceType = !!this.sourceType;
      const hasSourceTrim = !!this.sourceTrim;
      const hasSourceLevel = !!this.sourceLevel;
      const hasSourceClass = !!this.sourceClass;
      const hasTargetType = !!this.targetType && this.targetType !== this.type;

      if (!hasSourceTrim) return false;

      if (hasSourceType || hasSourceLevel || hasSourceClass) {
        return true;
      }

      return false;
    },
    shouldUseCloneByType() {
      return !!this.sourceType && !!this.sourceTrim &&
             !this.sourceLevel && !this.sourceClass;
    },
    filteredAppreciations() {
      if (!this.searchAppreciation) return this.predefinedAppreciations;
      return this.predefinedAppreciations.filter(item =>
        item.toLowerCase().includes(this.searchAppreciation.toLowerCase())
      );
    },
  },
  props: {
    type: {
      type: String,
      enum: ["MS", "MP", "MT"],
      required: true,
    },
  },
  components: {},
  async created() {
    this.tableLoading = true;

    await apiClient
      .post("/classrooms/filter", {
        query: {
          status: "active",
        },
        aggregation: {
          $project: {
            _id: 1,
            name: 1,
            level: 1,
            bulletin: 1,
          },
        },
      })
      .then((res) => (this.classes = res.data))
      .catch((e) => {
        console.log(e);
      });

    this.filtredTable = this.activeData;

    this.schoolDetails = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0];
    let { start, end } = this.settings.schoolarYears.find(
      (el) => el._id == this.settings.activeSchoolarYear
    );

    start = new Date(start).getFullYear();
    end = new Date(end).getFullYear();

    this.schoolarYearName = end + " / " + start;
    this.schoolType = this.schoolDetails.type;
    if (!this.schoolType)
      notification.warning({
        message: this.$t("bulletin.typeIntrouvable"),
        description: this.$t("bulletin.saisirSchoolType"),
      });
    this.updateCertifParams();
    await this.fetchPredefinedAppreciations();
  },
  data() {
    return {
      targetType: null,
      builletinTypesNames: {
        MP: this.$t("bulletin.bulletinPedagogique"),
        MT: this.$t("bulletin.bulletinSpecifique"),
        MS: this.$t("bulletin.bulletinVerySpecifique"),
      },
      visibleClone:false,
      pdfBlobUrl: "",
      certifParams: [],
      visibleAllFinalBulletin: false,
      bulletinDate: new Date(),
      moyenne: "--",
      schoolType: null,
      schoolDetails: {},
      filtredTable: [],
      selectedStudent: this.$t("menu.liste"),
      selectedStudentName: "",
      studentLoading: false,
      selectedTrimester: "1",
      selectedClasse: null,
      tableLoading: false,
      loadingPdfPreview: false,
      activeData: [],
      appreciations: [],
      loadingSave: false,
      loadingDelete: false,
      currentAppreciation: "",
      visibleAppreciationModal: false,
      selectedStudentRecord: {},
      rowData: [],
      data1: null,
      classes: [],
      editable: false,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      listModules: [],
      selectedLevel: null,
      selectedClassName: "",
      bulletinData: {},
      affichageData: {},
      sourceType: undefined,
      sourceTrim: undefined,
      sourceLevel: undefined,
      sourceClass: undefined,
      targetType: undefined,
      loadingClone: false,
      selectedRowKeys: [],
      visibleBulkAppreciation: false,
      bulkLoading: false,
      bulkAppreciationForm: this.$form.createForm(this, { name: 'bulk_appreciation' }),
      predefinedAppreciations: [],
      searchAppreciation: '',
      customAppreciation: '',
      selectedPredefinedAppreciation: null,
    };
  },
  methods: {
    moment,
    async onStudentClick(record) {
      try {
        this.selectedStudentRecord = record;
        this.visibleAppreciationModal = true;
        this.loadingPdfPreview = true;

        let studentApp = this.appreciations.find(
          (el) => String(el.student) == record._id
        );
        this.currentAppreciation = studentApp ? studentApp.appreciation : "";
        this.showPreview(record);
      } catch (error) {
        console.error(error);
      }
    },
    getStudentMoyenne(studentID) {
      try {
        if (!this.bulletinData) return "--";
        const student = this.bulletinData.students.find(
          (el) => el.id == studentID
        );
        return student ? student.moyenne : "--";
      } catch (error) {
        return "--";
      }
    },
    getStudentAppreciation(studentID) {
      if (this.appreciations.length == 0) return "--";
      const app = this.appreciations.find(
        (el) => String(el.student) == studentID
      );
      return app ? app.appreciation : "--";
    },

    async updateAdminAppreciations() {
      await apiClient
        .post("/adminAppreciation/filter", {
          query: {
            schoolarYear: this.settings.activeSchoolarYear,
            trimester: this.selectedTrimester,
            classroom: this.selectedClasse,
            type: this.type,
          },
        })
        .then(({ data }) => {
          this.appreciations = data;
        });
    },

    async saveStudentAppreciation(studentID) {
      this.loadingSave = true;
      const app = this.appreciations.find(
        (el) => String(el.student) == studentID
      );

      if (app) {
        await apiClient
          .patch("/adminAppreciation/" + app._id, {
            appreciation: this.currentAppreciation,
          })
          .then((res) => {
            app.appreciation = this.currentAppreciation;
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        await apiClient
          .put("/adminAppreciation", {
            appreciation: this.currentAppreciation,
            student: studentID,
            trimester: this.selectedTrimester,
            schoolarYear: this.settings.activeSchoolarYear,
            classroom: this.selectedClasse,
            type: this.type,
          })
          .then((res) => {
            this.appreciations.push(res.data);
          });
      }

      this.$message.success(this.$t("appreciation.saved"));
      await this.updateBulletins();
      this.showPreview(this.selectedStudentRecord, true);
      this.loadingSave = false;
    },

    async deleteStudentAppreciation(studentID) {
      this.loadingDelete = true;
      const app = this.appreciations.find(
        (el) => String(el.student) == studentID
      );

      if (app)
        await apiClient.delete("/adminAppreciation/" + app._id).then((res) => {
          this.appreciations = this.appreciations.filter(
            (el) => el._id != app._id
          );
        });

      this.$message.success(this.$t("appreciation.deleted"));

      this.currentAppreciation = "";
      this.selectedPredefinedAppreciation = null;
      await this.updateBulletins();
      await this.showPreview(this.selectedStudentRecord, true);
      this.loadingDelete = false;
    },

    async updateCertifParams() {
      await apiClient
        .get(`/certification/${this.type}`)
        .then((res) => {
          this.certifParams = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getCertificationNameByMoyenne(moyenne) {
      for (const cert of this.certifParams)
        if (
          Number(moyenne) >= Number(cert.min) &&
          Number(moyenne) <= Number(cert.max)
        )
          return cert.name;
      return "";
    },

    async updateBulletins() {
      this.tableLoading = true;
      await apiClient
        .get(
          `/bulletin/v2/bt/${this.type}/all/` +
            this.selectedClasse +
            "/" +
            this.selectedTrimester
        )
        .then(({ data }) => {
          this.bulletinData = data;
        })
        .catch((error) => {
          console.error("error ", error);
        })
        .finally(() => (this.tableLoading = false));
    },

    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },

    async handleClassChange(on, value) {
      this.selectedStudent = null;
      this.selectedStudentName = "";
      this.studentLoading = true;
      this.tableLoading = true;
      this.selectedClasse = value;
      this.selectedClassName = this.classes.find(
        (item) => item._id === value
      ).name;
      this.selectedLevel = this.classes.find(
        (item) => item._id === value
      ).level;
      this.selectedRowKeys = [];
      let match = {};
      match[`schoolarYearsHistory.${this.settings.activeSchoolarYear}`] = value;
      await apiClient
        .post("/students/filter", {
          query: { status: "active" },
          aggregation: [
            {
              $match: match,
            },
            {
              $set: {
                classRoom: {
                  $convert: {
                    input: `$schoolarYearsHistory.${this.settings.activeSchoolarYear}`,
                    to: "objectId",
                    onError: null,
                    onNull: null,
                  },
                },
              },
            },
            {
              $lookup: {
                from: "classrooms",
                localField: "classRoom",
                foreignField: "_id",
                as: "classroom",
              },
            },
            {
              $project: {
                _id: 1,
                firstName: 1,
                middleName: 1,
                lastName: 1,
                gender: 1,
                classroom: {
                  _id: 1,
                  name: 1,
                },
              },
            },
            {
              $sort: {
                firstName: 1,
              },
            },
          ],
        })
        .then(({ data }) => {
          this.rowData = [];
          data.map((elem) => {
            try {
              this.rowData.push({
                _id: elem._id,
                key: elem._id,
                fullName: elem.firstName + (elem.middleName ? " " + elem.middleName : "") + " " + elem.lastName,
                classroom: elem.classroom[0].name,
                classroom_id: elem.classroom[0]._id,
                gender: elem.gender,
              });
            } catch {}
          });
          this.activeData = this.rowData;
          this.filtredTable = this.activeData;
          this.studentLoading = false;
        });

      await this.updateBulletins();
      this.updateAdminAppreciations();

      this.tableLoading = false;
    },
    async fetchAffichageBulletin() {
      await apiClient
        .post("/bulletin/v2/affichage/list", {
          status: "active",
          isTemplate: false,
          level: Number(this.selectedLevel),
          trimester: Number(this.selectedTrimester),
          schoolarYear: String(this.settings.activeSchoolarYear),
          type: this.type,
        })
        .then(({ data }) => {
          if (data.length > 0) {
            this.affichageData = data[0];
          } else {
            this.$message.info(this.$t("bulletin.noTemplateFound"));
          }
        })
        .catch((e) => {
          console.error(e);
          this.$message.error(this.$t("bulletin.noTemplateFound"));
        });
    },
    //generate bulletin pdf
    async showPreview(student, isPreview = false) {
      try {
        await this.fetchAffichageBulletin();

        let btData = this.bulletinData.students.find(
          (el) => el.id == student._id
        );
        let studentData = this.activeData.find(
          (el) => el._id == student._id
        );
        let bloburl;
        if (this.type=="MP"){
          bloburl = await bulletinHeplers["MP"].printBulletin(
          this.affichageData,
          btData,
          btData,
          {
          selectedLevel: this.selectedLevel,
          schoolDetails: this.schoolDetails,
          selectedStudent: student._id,
          bulletinDate: this.bulletinDate,
          certifs: this.certifParams,
          selectedClassName: this.selectedClassName,
          schoolarYearName: this.schoolarYearName,
          selectedTrimester: this.selectedTrimester,
          selectedStudentName: student.fullName,
          settings: this.settings,
          selectedClasse: this.selectedClasse,
        },
          true
        )
        }else{
          bloburl = await bulletinHeplers[this.type].printBulletin(
          {...this.affichageData,side:{...this.affichageData.side, adminAppreciation:true}},
          studentData,
          btData,
          {
            ...this.settings,
            ...this.user,
            certif:this.certifParams
          },
          true
        )
        }

        this.pdfBlobUrl = bloburl;
        this.loadingPdfPreview = false;
      } catch (error) {
        console.error(error);
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSourceTypeChange() {
      this.targetType = undefined;
      this.validateCloneForm();
    },
    handleSourceLevelChange() {
      this.validateCloneForm();
    },
    handleSourceClassChange() {

      this.validateCloneForm();
    },
    validateCloneForm() {
      this.isCloneFormValid = this.isCloneFormValid();
    },
    async handleClone() {
      if (!this.isCloneFormValid) return;

      this.loadingClone = true;

      try {
        const query = {
          fromType: this.sourceType || this.type,
          fromTrimster: this.sourceTrim,
          schoolarYear: this.settings.activeSchoolarYear,
          toType: this.targetType || this.sourceType
        };

        if (this.sourceClass) {
          query.fromClassroom = this.sourceClass;
        } else if (this.sourceLevel) {
          query.level = this.sourceLevel;
        }

        const endpoint = this.shouldUseCloneByType ?
          '/adminAppreciation/cloneByType' :
          '/adminAppreciation/clone';

        await apiClient.post(endpoint, { query });

        this.$message.success(this.$t('appreciation.cloneSuccess'));
        this.visibleClone = false;
        this.updateAdminAppreciations();
      } catch (error) {
        console.error('Error cloning appreciations:', error);
        this.$message.error(error.response?.data?.message || this.$t('appreciation.cloneError'));
      } finally {
        this.loadingClone = false;
      }
    },
    openCloneModal() {
      this.visibleClone = true;
      this.sourceType = undefined;
      this.sourceTrim = undefined;
      this.sourceLevel = undefined;
      this.sourceClass = undefined;
      this.targetType = undefined;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    showBulkAppreciationModal() {
      this.visibleBulkAppreciation = true;
      this.searchAppreciation = '';
      this.$nextTick(() => {
        this.bulkAppreciationForm.resetFields();
      });
    },

    closeBulkAppreciationModal() {
      this.visibleBulkAppreciation = false;
      this.bulkLoading = false;
    },
    async handleBulkAppreciation() {
  this.bulkLoading = true;
  try {
    const values = await this.bulkAppreciationForm.validateFields();

    if (!this.selectedClasse) {
      throw new Error(this.$t('validation.selectClassFirst'));
    }

    const appreciation = values.selectedAppreciation || values.customAppreciation;

    if (!appreciation) {
      throw new Error(this.$t("bulletin.pleaseSelectOrTypeAppreciation"));
    }

    await apiClient.post('/adminAppreciation/many', {
      query: {
        classroom: this.selectedClasse,
        type: this.type,
        appreciation: appreciation,
        studentList: this.selectedRowKeys,
        trimester: this.selectedTrimester
      }
    });

    this.$message.success(this.$t('appreciation.bulkSuccess', { count: this.selectedRowKeys.length }));
    this.closeBulkAppreciationModal();
    this.selectedRowKeys = [];
    await this.updateAdminAppreciations();
  } catch (error) {
    console.error('Error in bulk appreciation:', error);
    const errorMessage = error.response?.data?.message || error.message || this.$t('appreciation.bulkError');
    this.$message.error(errorMessage);
  } finally {
    this.bulkLoading = false;
  }
},
    filterAppreciation(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleSearchAppreciation(value) {
      this.searchAppreciation = value;
      // Update the form value when typing
      this.bulkAppreciationForm.setFieldsValue({
        appreciation: value
      });
    },
    handleAppreciationChange(value) {
      this.customAppreciation = value;
    },
    handlePredefinedSelect(value) {
      if (value) {
        this.bulkAppreciationForm.setFieldsValue({
          customAppreciation: ''
        });
      }
    },

    handleCustomInput(e) {
      if (e.target.value) {
        this.bulkAppreciationForm.setFieldsValue({
          selectedAppreciation: undefined
        });
      }
    },
    async fetchPredefinedAppreciations() {
      try {
        const response = await apiClient.post("/bulletin/v2/static-admin-appreciation/filter", {
          modelName: "StaticAdminAppreciation",
          query: { }
        });
        this.predefinedAppreciations = response.data.map(item => item.appreciation);
      } catch (error) {
        console.error('Error fetching predefined appreciations:', error);
        this.predefinedAppreciations = [];
      }
    },
    handleTrimesterChange(val) {
      this.selectedTrimester = val;
      this.selectedRowKeys = [];
      this.updateBulletins();
      this.updateAdminAppreciations();
    },
    handlePredefinedAppreciationSelect(value) {
      if (value) {
        this.currentAppreciation = value;
      }
    },
    handleCustomAppreciationInput(e) {
      if (e.target.value) {
        this.selectedPredefinedAppreciation = null;
      }
    },
  },
};
</script>
<style scoped>
.arabic-font {
  font-size: 14px !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif !important;
}

.success .ant-btn-danger {
  background: #8bc34a !important;
  border-color: #8bc34a !important;
}

::v-deep .editable-row:hover {
  cursor: pointer;
}

.appreciation-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
